import React from 'react';
import CryptoTicker from '../components/CryptoTicker';
import WaitlistHeader from '../components/WaitlistHeader';
import WaitlistHero from '../components/WaitlistHero';
import WaitlistFeatures from '../components/WaitlistFeatures';
import WaitlistCounter from '../components/WaitlistCounter';
import WaitlistForm from '../components/WaitlistForm';
import WaitlistFooter from '../components/WaitlistFooter';

const Landing = () => {
  return (
    <div className="min-h-screen bg-black text-white overflow-hidden">
      <CryptoTicker />
      <WaitlistHeader />
      <WaitlistHero />
      <WaitlistFeatures />
      <WaitlistCounter />
      <WaitlistForm />
      <WaitlistFooter />
    </div>
  );
};

export default Landing;
